import React from "react";

export default function PageHeader({ eyebrow, title, subtitle, actions }) {
  return (
    <div
      className="px-10 py-7 flex items-end justify-between gap-6 border-b"
      style={{
        borderColor: "var(--border-subtle)",
        background: "linear-gradient(180deg, var(--bg-app) 0%, var(--bg-base) 100%)",
      }}
    >
      <div className="min-w-0">
        {eyebrow && <div className="eyebrow-accent mb-2">{eyebrow}</div>}
        <h1 className="font-display text-3xl font-bold tracking-tight" style={{ color: "var(--text-primary)" }}>
          {title}
        </h1>
        {subtitle && (
          <div className="text-sm mt-1.5 max-w-2xl" style={{ color: "var(--text-muted)" }}>
            {subtitle}
          </div>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}

export function StatusPill({ status }) {
  const label = (status || "draft").toUpperCase();
  return (
    <span className={`status-pill ${status || "draft"}`} data-testid={`status-${status}`}>
      <span className={`dot ${status || "draft"}`}></span>
      {label}
    </span>
  );
}
